export const IsEmailSuperAdmin = (email: string) => {
  var emailDomains = process.env.NEXT_PUBLIC_ADMIN_EMAIL_DOMAINS?.split(",");
  return emailDomains?.some((domain) => email.endsWith(`@${domain}`));
};

export const IsSuperAdmin = (user: { email?: string } | undefined): boolean => {
  return user ? IsEmailSuperAdmin(user?.email || "") ?? false : false;
};

export const shouldShowTermsAcceptanceModal = (
  needsSigning: boolean | undefined,
  user?: { email?: string }
): boolean => Boolean(needsSigning) && !IsSuperAdmin(user);
